import './Constructor.css';const constructor__loader = "_constructor__loader_1v2lf_1";
const styles = {
  constructor__loader
};
export {
  constructor__loader,
  styles as default
};
